export type MerchantRow = Record<string, unknown>;
export type MerchantOverview = { merchant?: MerchantRow; applications?: MerchantRow[]; places?: MerchantRow[] };
const approved = new Set(['approved', 'verified']);
const waiting = new Set(['submitted', 'pending', 'pending_review', 'under_review', 'pending_owner_approval']);
export function merchantAccess(data: MerchantOverview | null) {
  const verified = approved.has(String(data?.merchant?.status || '').toLowerCase()) && Boolean(data?.places?.length);
  const pending = (data?.applications || []).some(item => waiting.has(String(item.status || '').toLowerCase()));
  return { verified, pending, allowed: verified || pending };
}
